/**
 * Save all field's data in localStorage. Load it when page is loaded.
 */
const fluxLocalStorage = {
    init: function () {

        if ( !flux_checkout_vars || '1' != flux_checkout_vars.store_checkout_data ) {
            return;
        }

        fluxLocalStorage.load_data();
        fluxLocalStorage.watch_data_change();
    },

    /**
     * Watch data change and save in localStorage as JSON.
     */
    watch_data_change: function () {
        const inputs = document.querySelectorAll( 'form.checkout input, form.checkout textarea, form.checkout select' );
        Array.from( inputs ).forEach( input => {
            input.addEventListener( 'change', e => {
                const form = input.closest( 'form' );
                if ( ! form ) {
                    return;
                }

                const form_data = fluxLocalStorage.formSerialize( form );
                const json = JSON.stringify( form_data );
                localStorage.setItem( 'iconic_flux_checkout_form_data', json );
            })
        });
    },

    /**
     * Load data from localStorage and populate fields.
     */
    load_data: function () {
        const json = localStorage.getItem( 'iconic_flux_checkout_form_data' );
        const form = document.querySelector( 'form.checkout' );
        if ( ! json ) {
            return;
        }

        const single_checkbox = [ 'order_notes_switch', 'show_shipping' ];
        const data = JSON.parse( json );
        
        if ( 'object' !== typeof data ) {
            return;
        }

        data.forEach( fieldData => {
            const field = form.querySelector( '[name="' + window.CSS.escape( fieldData.name ) + '"]' );

            if ( ! field ) {
                return;
            }

            if ( flux_checkout_vars.localstorage_fields.includes( fieldData.name ) && fieldData.value && '' == field.value ) {
                field.value = fieldData.value;
                field.dispatchEvent( new Event( 'change' ) );
            }

            if ( single_checkbox.includes( fieldData.name ) && 'on' === fieldData.value ) {
                field.setAttribute( 'checked', true );
                field.dispatchEvent( new Event( 'change' ) );
            }
        } );
    },

    formSerialize: function ( formElement ) {
        const values = [];
        const inputs = formElement.elements;

        for (let i = 0; i < inputs.length; i++) {
            values.push(
                {
                    name: inputs[i].name,
                    value: inputs[i].value,
                }
            );
        }
        return values;
    }
};

export default fluxLocalStorage;